export enum DeviceStatus {
  Ok = 'OK',
  Warning = 'WARNING',
  Error = 'ERROR',
}
